import {
  Body2,
  Button,
  Card,
  CardFooter,
  CardHeader,
  Title2,
} from "@fluentui/react-components";

export const TeamInstallationRequired = ({
  redirect: { url, openInNewTab = false },
}: {
  redirect: {
    url: string;
    openInNewTab: boolean;
  };
}) => (
  <Card size="large" className="w-full max-w-lg">
    <CardHeader header={<Title2>Installation required</Title2>} />
    <Body2>
      You have to install BeZoned for your tenant first and then go through
      onboarding process in the app. Then you can add BeZoned to individual
      teams.
    </Body2>
    <CardFooter className="flex justify-end gap-2">
      <Button
        appearance="primary"
        as="a"
        href={url}
        rel={openInNewTab ? "noopener noreferrer" : undefined}
        target={openInNewTab ? "_blank" : undefined}
      >
        Open Lobby
      </Button>
    </CardFooter>
  </Card>
);
